import { render, staticRenderFns } from "./Reservation_New.vue?vue&type=template&id=bdc58370&"
import script from "./Reservation_New.vue?vue&type=script&lang=js&"
export * from "./Reservation_New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports